// Este componente actúa como un marcador temporal mientras se desarrollan
// las pantallas reales. Para reemplazarlo, crea tu componente final y
// actualiza la definición de rutas para que importe esa pantalla en lugar
// de Placeholder.
export function Placeholder({ title }) {
  return (
    <section className="placeholder">
      <h1>{title}</h1>
      <p>Pantalla en construcción. Aquí irá {title}.</p>
    </section>
  );
}

export default Placeholder;
